import getAPI from './getAPI.js'

export default async function getAdobeSignTemplates() {
    const data = await getAPI('admin/adobesign/templates');
    return data;
}
